<ngx-nativeapp-advert></ngx-nativeapp-advert>

<div class="row">
  <div class="col">
    <h2>{{ patient.firstName + ' ' + patient.lastName }}'s Program</h2>
  </div>
</div>

<ngx-patient-calendar  [isClientView]="true" [patient]="patient"></ngx-patient-calendar>

<div style="height: 100px;"></div>